'use client';

import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Mount this component once in the root layout.
 * It has no visible output — it only fires a toast when a new
 * frontend build is detected.
 */
export function VersionChecker() {
  useVersionCheck();
  return null;
}
